import { LandingPageDestination } from '@dtx-company/inter-app/src/types/flowcode'
import { LinkInfoFragment } from '@dtx-company/flow-codegen/src/page/generated.types'
import { constructSMSLink } from '@dtx-company/flowcode-utils/src'

export const getSocialsLandingPageDestination = (
  provider: LinkInfoFragment['provider'],
  type?: LinkInfoFragment['type']
): LandingPageDestination => {
  switch (provider) {
    case 'instagram':
      return LandingPageDestination.INSTAGRAM
    case 'tiktok':
      return LandingPageDestination.TIKTOK
    case 'venmo':
      return LandingPageDestination.VENMO
    case 'snapchat':
      return LandingPageDestination.SNAPCHAT
    case 'twitter':
      return LandingPageDestination.TWITTER
    case 'linkedin':
      return LandingPageDestination.LINKEDIN
    case 'youtube':
      return LandingPageDestination.YOUTUBE
    case 'facebook':
      return LandingPageDestination.FACEBOOK
    case 'spotify':
      return LandingPageDestination.SPOTIFY
    case 'email':
      return LandingPageDestination.EMAIL
    case 'sms':
      return LandingPageDestination.SMS
    case 'call':
      return LandingPageDestination.PHONE
    case 'widget':
      if (type === 'bigImage') return LandingPageDestination.FILE
      else if (type === 'pdf') return LandingPageDestination.PDF
      else return LandingPageDestination.URL
    default:
      return LandingPageDestination.URL
  }
}

export const getWidgetLinkForCode = (link: LinkInfoFragment): string => {
  switch (link.type) {
    case 'bigImage':
      return link?.thumbNailImgUrl ?? ''
    case 'contactInfo':
      //only supports sms widget
      return (
        constructSMSLink({
          message: '',
          phoneNumber: link?.actionData?.text
        }) ?? ''
      )
    case 'pdf':
      return link?.actionData?.link ?? ''
    default:
      return ''
  }
}
